import * as UsuarioAPI from '../api/usuario';
import moment from 'moment';

// Função utilitária para obter permissões do usuário
export const obterPermissoesUsuario = async (pessoaId, empresaId, ul, li) => {
    try {
        const permissoes = await UsuarioAPI.permissoes(pessoaId, empresaId, ul, li);

        if (permissoes.length === 0) {
            // Redirecionar para a página inicial se o usuário não tiver permissões
            return { sucesso: false, mensagem: 'Usuário sem permissões.' };
        }

        // Armazenar permissões no localStorage
        localStorage.setItem('incluir', permissoes[0].incluir);
        localStorage.setItem('editar', permissoes[0].editar);
        localStorage.setItem('imprimir', permissoes[0].imprimir);
        localStorage.setItem('cancelar', permissoes[0].cancelar);
        localStorage.setItem('cancelarBaixa', permissoes[0].cancelarBaixa);
        localStorage.setItem('editarItem', permissoes[0].editarItem);
        localStorage.setItem('imprimirItem', permissoes[0].imprimirItem);
        localStorage.setItem('cancelarItem', permissoes[0].cancelarItem);
        localStorage.setItem('baixar', permissoes[0].baixar);
        localStorage.setItem('transformar', permissoes[0].transformar);
        localStorage.setItem('custos', permissoes[0].custos);
        localStorage.setItem('usuario', permissoes[0].usuario);
        localStorage.setItem('conferir', permissoes[0].conferir);
        localStorage.setItem('reajustarPreco', permissoes[0].reajustarPreco);

        localStorage.setItem('impAnalitico', permissoes[0].impAnalitico);
        localStorage.setItem('impGerencia', permissoes[0].impGerencia);
        localStorage.setItem('impSintetico', permissoes[0].impSintetico);

        return { sucesso: true, mensagem: 'Permissões obtidas com sucesso.' };
    } catch (erro) {
        // Lidar com erros, por exemplo, logar ou lançar uma exceção
        console.error('Erro ao obter permissões:', erro);
        return { sucesso: false, mensagem: 'Erro ao obter permissões.' };
    }
};

export const corrigirDataColumnFilters = (columnFilters, objeto) => {
    const idsTipoData = objeto && objeto.length > 0 ? objeto : ['data', 'dataBaixa', 'dataVencimento', 'dataLancamento'];

    // Formata os filtros de datas apenas se necessário
    const formattedFilters = columnFilters.map((filter) => {
        if (idsTipoData.includes(filter.id)) {
            const formattedValue = Array.isArray(filter.value)
                ? filter.value.map((val) => moment(val).add(3, 'hours').startOf('day').format('YYYY-MM-DD'))
                : moment(filter.value).add(3, 'hours').startOf('day').format('YYYY-MM-DD');
            return { ...filter, value: formattedValue };
        }
        return filter;
    });

    return formattedFilters;
};
//funções para corrigir a data no mrt
export const getDateFilterIds = (campos) => {
    const dateIds = [
        'data',
        'dataBaixa',
        'dataVencimento',
        'dataLancamento',
        'dataFaturamento',
        'primeiraDataVencimento',
        'dataSaida',
        'dataEntrada',
        'dataNascimento',
        'cnhValidade',
        'cnhExameToxicologicoValidade',
        'abertura',
        'cnhPrimeira',
        'dataCompra',
        'dataVenda',
    ];

    return Array.isArray(campos) && campos.length > 0 ? campos : dateIds;
};
export const precisaCorrigirDataColumnFiltersObjeto = (columnFilters, campos) => {
    const camposIds = getDateFilterIds(campos);

    return (
        Array.isArray(columnFilters) &&
        columnFilters.some((filter) => {
            if (!camposIds.includes(filter.id)) return false;
            if (!Array.isArray(filter.value)) return false;

            return filter.value.some((val) => typeof val === 'string');
        })
    );
};
/**
 * Transforma o array string em objeto para o dataPicker mostrar a data corretamente
 * @param {*} columnFilters
 * @param {*} campos é um array dos nomes dos campos da tabela
 * @returns
 */
export const corrigirDataColumnFiltersObjeto = (columnFilters, campos) => {
    const camposIds = getDateFilterIds(campos);

    return columnFilters.map((filter) => {
        const newValue =
            camposIds.includes(filter.id) && Array.isArray(filter.value)
                ? filter.value.map((val) => new Date(val))
                : filter.value; // Mantém o valor original se não for um campo de data

        return { ...filter, value: newValue };
    });
};

//simplifica o codigo ao imprimir o pdf
export const printPdf = (obj) => {
    // Cria um Blob a partir do objeto do arraybuffer
    const pdfBlob = new Blob([obj], {
        type: 'application/pdf',
    });

    // Cria um URL temporário para o Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Use o URL do PDF para abrir em uma nova janela ou realizar outras ações
    window.open(pdfUrl);
};

/**
 * Retorna o id do item cujo value é exatamente igual ao digitado,
 * comparando pelos campos usados no datalist.
 */
export const pickSelectedId = (value, list, displayField = 'descricao') => {
    const norm = (s) =>
        String(s ?? '')
            .trim()
            .toLowerCase();

    const v = norm(value);
    if (!v) return null;

    const found = (list || []).find((o) =>
        [o?.[displayField], o?.id, o?.label, o?.codigo, o?.codigoBarras, o?.ncm].some((x) => norm(x) === v)
    );

    return found?.id ?? null;
};

// Helpers
const isPlainObject = (v) =>
    v !== null && typeof v === 'object' && !Array.isArray(v) && Object.prototype.toString.call(v) === '[object Object]';

function mergeArrays(prev, next, { arrayMode, idKey }) {
    const prevArr = Array.isArray(prev) ? prev : [];
    const nextArr = Array.isArray(next) ? next : [];

    switch (arrayMode) {
        case 'concat':
            // concatena (não de-duplica)
            return [...prevArr, ...nextArr];

        case 'byId':
            // ideal p/ arrays de objetos com {id}: faz upsert mantendo dados antigos
            const byId = new Map();
            for (const item of prevArr) {
                const key = isPlainObject(item) ? item[idKey] : undefined;
                byId.set(key ?? Symbol(), item);
            }
            for (const item of nextArr) {
                const key = isPlainObject(item) ? item[idKey] : undefined;
                if (key !== undefined && byId.has(key)) {
                    const merged = deepMergeDefined(byId.get(key), item, { arrayMode, idKey });
                    byId.set(key, merged);
                } else {
                    byId.set(key ?? Symbol(), item);
                }
            }
            // mantém a ordem do "next" primeiro, depois os remanescentes do "prev" sem id
            const ordered = [];
            const seen = new Set();
            for (const item of nextArr) {
                const key = isPlainObject(item) ? item[idKey] : undefined;
                const realKey = key ?? [...byId.keys()].find((k) => byId.get(k) === item);
                if (!seen.has(realKey)) {
                    ordered.push(byId.get(realKey));
                    seen.add(realKey);
                }
            }
            for (const [k, v] of byId) {
                if (!seen.has(k)) ordered.push(v);
            }
            return ordered;

        case 'replace':
        default:
            // substitui o array por completo
            return [...nextArr];
    }
}
/**
 * Deep merge que ignora valores undefined/null vindos de `next`.
 *
 * options:
 *  - arrayMode: 'replace' | 'concat' | 'byId' (default: 'replace')
 *  - idKey: usado no modo 'byId' (default: 'id')
 *  - onMerge?: (prevVal, nextVal, keyPath) => any   // gancho opcional
 */
export function deepMergeDefined(prev, next = {}, options = {}) {
    const { arrayMode = 'replace', idKey = 'id', onMerge } = options;

    // se next inválido, mantém prev
    if (next === null || next === undefined) return prev;

    // primitivos / funções / datas: substitui direto (exceto undefined/null, já filtrado)
    if (!isPlainObject(next) && !Array.isArray(next)) return next;

    // objetos
    if (isPlainObject(next)) {
        const out = isPlainObject(prev) ? { ...prev } : {};
        for (const [k, v] of Object.entries(next)) {
            if (v === undefined || v === null) continue; // ignora "apagadores"
            const current = out[k];

            const merged = onMerge ? onMerge(current, v, [k]) : undefined; // gancho opcional
            if (merged !== undefined) {
                out[k] = merged;
                continue;
            }

            if (isPlainObject(v)) {
                out[k] = deepMergeDefined(current, v, options);
            } else if (Array.isArray(v)) {
                out[k] = mergeArrays(current, v, { arrayMode, idKey, options });
            } else {
                out[k] = v; // primitivo
            }
        }
        return out;
    }

    // arrays
    if (Array.isArray(next)) {
        return mergeArrays(prev, next, { arrayMode, idKey, options });
    }

    return next;
}
/*
uso
setDados(prev => deepMergeDefined(prev, formData, { arrayMode: "replace" }));
setDados(prev => deepMergeDefined(prev, { movimentoItems: novos }, { arrayMode: "byId" }));


*/
//resolve se a empresa usa o modo de tabelas comuns ou não, para retornar o id da empresa correta
export function resolveEmpresaTabela(parametro, empresaId) {
    return parametro?.tabelasComuns ? 1 : empresaId;
}
